import { createSelector } from 'reselect';

export const containerState = (state) => state.Cache;

export const cachedImages = createSelector(
	containerState,
	(state) => state.images.entries,
);
